module.exports = __webpack_public_path__ + "static/media/1 9 00.60b0fd99.png";